// globals
const counterItems = [{
  amount: '5 M+',
  title: 'Users' // rolling numbers
},
{
  amount: '60,000',
  title: 'Requests / Second'
},
{
  amount: '1,394,238,392', // ticking up
  title: 'Messages Sent'
},
{
  className: 'iconItem',
  amount: '32',
  title: 'Engagement'
},
{
  className: 'iconItem',
  amount: '14',
  title: 'Retention'
},
{
  className: 'iconItem',
  amount: '  9',
  title: 'Monetization'
}];

// exported data
const data = {
  counterItems
};

// exports
export default data;